import { createBrowserRouter, Navigate } from 'react-router-dom';
import DefaultLayout from '../components/DefaultLayout.js';
import GuestLayout from '../components/GuestLayout.js';
import Dashboard from '../views/dashboard/Dashboard.js';
import Login from '../views/login/Login.js';
import NotFound from '../views/NotFound.js';
import Medicines from '../views/medicines/Medicines.js';
import MedicinesEdit from '../views/medicines/MedicinesEdit.js';
import MedicinesAdd from '../views/medicines/MedicinesAdd.js';
import Financial from '../views/financial/Financial.js';
import ReportSales from '../views/financial/ReportSales.js';
import ReportBalance from '../views/financial/ReportSalesBalance.js';
import Sales from '../views/sales/Sales.js';
import SalesEdit from '../views/sales/SalesEdit.js';
import ProtectedRoute from '../components/ProtectedRoute.js';
import Unauthorized from '../views/Unauthorized.js';
import BudgetDetails from '../views/sales/BudgetDetails.js';
import ImpressoraAchemed from '../views/ImpressoraAchemed.js';
import SalesExams from '../views/sales/SalesExams.js';

// Rotas de "Medicines"
const medicinesRoutes = [
    {
        path: '/medicines',
        element: <Medicines />,
    },
    {
        path: '/medicines/:id',
        element: <MedicinesEdit />
    },
    {
        path: '/medicines/add',
        element: <MedicinesAdd />
    },
];

// Rotas de "Financial"
const financialRoutes = [
    {
        path: '/financial',
        element: <Financial />,
    },
    {
        path: '/financial/report/sales',
        element: <ReportSales />,
    },
    {
        path: '/financial/report/balance',
        element: <ReportBalance />,
    }
];

const salesRoutes = [
    {
        path: '/sales/medicines',
        element: (
            <ProtectedRoute rolesAllowed={["Administrator", "Receptionist"]}>
                <Sales />
            </ProtectedRoute>
        )
    },
    {
        path: '/sales/exams',
        element: (
            <ProtectedRoute rolesAllowed={["Administrator", "Receptionist"]}>
                <SalesExams />
            </ProtectedRoute>
        )
    },
    {
        path: '/sales/:id',
        element: (
            <ProtectedRoute rolesAllowed={["Administrator", "Receptionist"]}>
                <SalesEdit />
            </ProtectedRoute>
        )
    },
    {
        path: '/orcamento/:id',
        element: (
            <BudgetDetails />
        )
    }
]


const router = createBrowserRouter([
    {
        path: '/',
        element: <DefaultLayout />,
        basename: '/',
        children: [
            {
                path: '/',
                element: <Navigate to="/dashboard" />
            },
            {
                path: '/dashboard',
                element: <Dashboard />
            },
            ...financialRoutes,
            ...medicinesRoutes,
            ...salesRoutes
        ]
    },
    {
        path: '/',
        element: <GuestLayout />,
        children: [
            {
                path: '/login',
                element: <Login />
            },
        ]
    },
    {
        path: '*',
        element: <NotFound />
    },
    {
        path: "/unauthorized",
        element: <Unauthorized />,
    },
    {
        path: '/impressora',
        element: <ImpressoraAchemed />
    }
])

export default router;
